export enum LayoutType {
    carousel = 'carousel',
    masonry = 'masonry',
    list = 'list',
    video = 'video',
}
